<template>
  <div class="report_container">
    <!-- 头部报料分类 -->
    <div class="report_category" v-if="categoryList.length > 1">
      <van-tabs class="report_category_tabs" @click="onTabClick" v-model="selectedIndex" swipe-threshold="2" :line-width="lineWidth">
        <van-tab v-for="item in categoryList" :title="item.name" :key="item.id">
        </van-tab>
      </van-tabs>
    </div>
    <div class="report_list_box">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="report_list_cont">
        <van-list v-model="loading" :offset="10" :immediate-check="false" :finished="finished" finished-text="没有更多了" @load="onLoadMore">
          <div class="category_img">
            <img :src="categoryImgSrc" alt="" v-if="!!categoryImgSrc && categoryImgSrc.length>0">
          </div>
          <report-list :contentList="reportDataList" :channelId="params.channelId"></report-list>
        </van-list>
      </van-pull-refresh>
    </div>
    <div class="edit_box">
      <van-icon name="edit" class="edit" @click="toAddReport" />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import reportApi from "@/api/apis/report.js";
import commApi from "@/api/apis/common.js";
import ReportList from "./components/ReportList";
export default {
  name: "Report",
  computed: {
    ...mapState("app", ["userInfo", "nodeCode", "appName"]),
  },
  components: {
    ReportList,
    contentType: null,
  },
  data() {
    return {
      selectedIndex: 0,
      lineWidth: 0, //Tab标签底部条宽度
      refreshing: false,
      loading: false,
      finished: false,
      categoryParams: {
        pageNo: 0,
        pageSize: 10,
      },
      categoryList: [],// 报料分类列表
      categoryImgSrc: null, // 当前选中的分类图片
      params: {
        channelId: null,
        streamStyle: null, //样式 1：新版的客户端需要的格式，空：老版
        sortType: 3, //3-最新，4-最热
        pageNo: 0,
        pageSize: 10,
      },
      reportDataList: [], //报料列表
      reportTotal: 0, //报料总数
      reportPageCount: 0, //报料分页数
      loadFirstPage: true, //是否加载第一页,用来解决vant上拉加载本身的缺陷问题
      shareUrl: "",
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path == "/index_share") {
        vm.shareUrl = location.href.replace("/report_list?", "/index_share?");
      } else {
        vm.shareUrl = location.href;
      }
    });
  },
  methods: {
    /* 微信二次分享 */
    wechatShare() {
      var _this = this;

      commApi.getWeiXinTicket({
        nodeCode: _this.nodeCode,
        url: _this.shareUrl
      }).then((res) => {
        _this.$WeiXin.shareWeiXin(res, _this.appName + "报料平台", "请问有什么可以帮到您？", _this.shareUrl);
      }).catch((err) => {

      })
    },
    /* 获取报料频道 */
    getReportChannelByCategory() {
      var _this = this;

      reportApi
        .listDiscloseChannelByCategoryCode(_this.categoryParams)
        .then((res) => {
          if (res.suc == 1) {
            _this.categoryList = res.data.list;
            _this.categoryList.push({ name: "我的", id: -1 });
            if (_this.categoryList.length > 0) {
              _this.params.channelId = _this.categoryList[0].id;
              _this.lineWidth = _this.categoryList[0].name.length * 14;
              if (!!_this.categoryList[0].imgUrl && _this.categoryList[0].imgUrl.length > 0) {
                _this.categoryImgSrc = _this.categoryList[0].imgUrl;
              } else {
                _this.categoryImgSrc = null;
              }
              if (_this.params.channelId == -1) {
                _this.getMyReportDataList();
              } else {
                _this.getReportDataList();
              }
            }
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 切换分类 */
    onTabClick(index) {
      var _this = this;
      _this.selectedIndex = index;
      _this.params.channelId = _this.categoryList[index].id;
      if (!!_this.categoryList[index].imgUrl && _this.categoryList[index].imgUrl.length > 0) {
        _this.categoryImgSrc = _this.categoryList[index].imgUrl;
      } else {
        _this.categoryImgSrc = null;
      }
      _this.lineWidth = _this.categoryList[index].name.length * 14;
      _this.params.pageNo = 0;
      _this.reportDataList = [];
      _this.reportTotal = 0;
      _this.reportPageCount = 0;
      _this.loadFirstPage = true;
      if (_this.finished) {
        _this.refreshing = false;
      } else {
        _this.refreshing = true;
      }
      _this.loading = false;
      _this.finished = false;
      if (_this.params.channelId == -1) {
        _this.getMyReportDataList();
      } else {
        _this.getReportDataList();
      }
    },
    /* 获取报料列表 */
    getReportDataList() {
      var _this = this;

      reportApi
        .listDiscloseMaterialByPublish(_this.params)
        .then((res) => {
          _this.refreshing = false;
          _this.loading = false;
          if (res.suc == 1) {
            if (_this.params.pageNo == 0) {
              _this.reportDataList = res.data.list;
            } else {
              _this.reportDataList = _this.reportDataList.concat(
                res.data.list
              );
            }
            _this.reportTotal = res.data.total;
            _this.reportPageCount = Math.ceil(
              res.data.total / _this.params.pageSize
            );
            if (_this.params.pageNo >= _this.reportPageCount - 1) {
              _this.finished = true;
            }
            _this.loadFirstPage = false;
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
            _this.finished = true;
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 获取我的报料列表  */
    getMyReportDataList() {
      var _this = this;

      if (!_this.userInfo) {
        _this.$router.push("/login");
        return;
      }

      var params = {
        memberId: _this.userInfo.id,
        pageNo: _this.params.pageNo,
        pageSize: _this.params.pageSize,
      }

      reportApi
        .listDiscloseMaterialByMemberId(params)
        .then((res) => {
          _this.refreshing = false;
          _this.loading = false;
          if (res.suc == 1) {
            if (_this.params.pageNo == 0) {
              _this.reportDataList = res.data.list;
            } else {
              _this.reportDataList = _this.reportDataList.concat(
                res.data.list
              );
            }
            _this.reportTotal = res.data.total;
            _this.reportPageCount = Math.ceil(
              res.data.total / _this.params.pageSize
            );
            if (_this.params.pageNo >= _this.reportPageCount - 1) {
              _this.finished = true;
            }
            _this.loadFirstPage = false;
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
            _this.finished = true;
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 下拉刷新 */
    onRefresh() {
      this.params.pageNo = 0;
      // this.reportDataList = [];
      this.reportTotal = 0;
      this.reportPageCount = 0;
      this.loadFirstPage = true;
      if (this.finished) {
        this.refreshing = false;
      } else {
        this.refreshing = true;
      }
      this.loading = false;
      this.finished = false;
      if (this.params.channelId == -1) {
        this.getMyReportDataList();
      } else {
        this.getReportDataList();
      }
    },
    /* 上拉加载 */
    onLoadMore() {
      if (!this.loadFirstPage) {
        this.params.pageNo++;
        if (this.params.pageNo < this.reportPageCount) {
          this.loading = true;
          if (this.params.channelId == -1) {
            this.getMyReportDataList();
          } else {
            this.getReportDataList();
          }
        }
      }
    },
    /* 跳转新增报料 */
    toAddReport() {
      if (!!this.userInfo) {
        this.$router.push("/report_new");
        return;
      } else {
        this.$router.push("/login");
        return;
      }
    }
  },
  created() {
    document.title = this.appName + "报料平台";
    let query = this.$route.query;
    if (Object.prototype.hasOwnProperty.call(query, "contentType") && query.contentType == "report") {
      this.getReportChannelByCategory();
      this.wechatShare();
    } else {
      this.$router.replace({
        path: "/error",
      });
    }
  },
};
</script>
<style scoped lang="scss">
.report_container {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0;
  overflow: hidden;
  .report_list_box {
    width: 100%;
    height: calc(100% - 44px);
    .report_list_cont {
      width: 100%;
      height: 100%;
      padding: 0;
      background-color: #f6f6f6;
      overflow-x: hidden;
      overflow-y: auto;
      .category_img {
        width: 100%;
        img {
          display: block;
          max-width: 100%;
          width: 100%;
        }
      }
    }
  }
  .edit_box {
    position: fixed;
    bottom: 50px;
    left: 50%;
    z-index: 100;
    width: 50px;
    height: 50px;
    transform: translate(-50%);
    text-align: center;
    line-height: 50px;
    background: red;
    border-radius: 50%;
    .edit {
      font-size: 32px;
      line-height: 50px;
      color: #eee;
    }
  }
}
</style>